<template>
  <div id="app" class="antialiased w-screen h-screen" v-cloak>
    <AppBar />
    <AppTransition>
      <router-view :key="$route.fullPath" />
    </AppTransition>
  </div>
</template>

<script>
import getScrollbarWidth from '@/common/getScrollbarWidth'

export default {
  name: 'App',

  mounted() {
    this.$store.set('app/scrollbarWidth', getScrollbarWidth())
  }
}
</script>

<style lang="postcss">
@import './design/main.pcss';

body {
  font-family: 'Roboto', sans-serif;
}
</style>
